import { createFileRoute, notFound } from "@tanstack/react-router"

import { MemberShell } from "@/components/member-shell"
import { PropertyEditor } from "@/components/property-editor"
import { getMyListingsFn } from "@/lib/app.functions"
import { requireMemberRoute } from "@/lib/route-guards"

export const Route = createFileRoute("/my-listings/$id/edit")({
  loader: async ({ params }) => {
    await requireMemberRoute(`/my-listings/${params.id}/edit`)
    const result = await getMyListingsFn()
    const property = result.listings.find(
      (listing) => listing.id === Number(params.id)
    )
    if (!property) throw notFound()
    return { user: result.user, property }
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData
          ? `Edit ${loaderData.property.title} · Harbor & Pine Realty`
          : "Edit listing · Harbor & Pine Realty",
      },
    ],
  }),
  component: EditListingPage,
})

function EditListingPage() {
  const { user, property } = Route.useLoaderData()
  return (
    <MemberShell
      user={user}
      eyebrow={`Owner workspace · ${property.reference}`}
      title="Edit listing"
      intro="Update the commercial facts, location context, dimensions, status, amenities, and lead media."
    >
      <PropertyEditor property={property} isAdmin={user.role === "admin"} />
    </MemberShell>
  )
}
